// extracted by mini-css-extract-plugin
module.exports = {"goToMapBtn":"RoutesList_goToMapBtn__3AXMk","goToMap":"RoutesList_goToMap__3NLnS"};